import { useMediaQuery } from 'react-responsive';
import sassVariables from '../../../../../assets/stylesheets/_settings.global.scss';

export default function useTheme() {
  const isMobile = useMediaQuery({ query: `(max-width: ${sassVariables.breakpointMediumMax})` });
  const isLarge = useMediaQuery({ query: `(min-width: ${sassVariables.breakpointLargeMin})` });
  return {
    ...sassVariables,
    isLarge,
    isMobile,
  };
}
